import styled from '@emotion/styled';
import classnames from 'classnames';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Col, Ellipsis, Form, InputNumber, Row } from 'ui/base';

import CountryPhoneSelect from './CountryPhoneSelect';

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
    
  &.required::before {
    content: '${({ requiredMark }) => requiredMark}';
    color: #c42137;
    margin-right: 4px;
    font-family: SimSun,sans-serif;
    flex-shrink: 0;
  }
`;

const PhoneField = ({ value: phoneNumber, onChange, error, hideError, disabled, required, hideLabel, ...rest }) => {
  const intl = useIntl();
  const handleLocalOnChange = React.useCallback(
    local => {
      onChange({ ...phoneNumber, local: local?.toString() });
    },
    [onChange, phoneNumber]
  );

  const validateStatus = error ? 'error' : undefined;
  const requiredMark = intl.formatMessage({ id: 'requiredMark', defaultMessage: '*' });

  return (
    <div>
      {!hideLabel && (
        <LabelWrapper className={classnames('pb-2', { required })} requiredMark={requiredMark}>
          <Ellipsis>
            <FormattedMessage id="page.fiche.form.client_information.phone_number" defaultMessage="Phone number" />
          </Ellipsis>
        </LabelWrapper>
      )}

      <Row type="flex">
        <Col flex="100px">
          {/** Prefix selector */}
          <Form.Item validateStatus={validateStatus}>
            <CountryPhoneSelect {...rest} value={phoneNumber} onChange={onChange} disabled={disabled} />
          </Form.Item>
        </Col>
        <Col className="pl-3" flex="auto">
          {/** Local definition */}
          <Form.Item validateStatus={validateStatus} help={!hideError && error}>
            <InputNumber
              {...rest}
              noFormat
              autoComplete="tel"
              data-cy="phoneNumber"
              className="phoneNumber-local"
              alignRight={false}
              disabled={disabled}
              value={phoneNumber.local}
              onChange={handleLocalOnChange}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default PhoneField;
